// extracted by mini-css-extract-plugin
export default {"Brands":"Brands_Brands__nayjO","swipe":"Brands_swipe__Eu-rY","brandImage":"Brands_brandImage__TXuKA","inner":"Brands_inner__uyVor","wrapper":"Brands_wrapper__zJCtQ"};